module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-32.874e8bed.png";